import { i18n } from 'lib/i18n.js';
import { isOver } from 'utils/general';
import { Pagination, A11y, Keyboard } from "swiper/modules";

export default {
  i18n,
  components: {
    'vue-swiper': () => import('../vue-swiper/vue-swiper.vue'),
    'product-review-highlight': () => import('./product-review-highlight.vue'),
  },
  props: ['productId', 'sectionTitle', 'yotpoKey'],
  data() {
    return {
      reviews: [],
      maxContent: 150,
      swiper: null,
      swiperOptions: {
        slidesPerView: 1,
        autoHeight: true,
        a11y: true,
        keyboard: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet: function (index, className) {
            return `<button class="${className}"></button>`;
          },
        },
        a11y: {
          enabled: true
        },
        on: {
          slideChange: this.handleSlideChange,
        },
        modules: [Pagination, A11y, Keyboard],
      }
    };
  },
  async mounted() {
    if (isOver(414)) {
      this.maxContent = 250;
    }
    await this.fetchReviews();
  },
  methods: {
    async fetchReviews() {
      const baseUrl = `https://api-cdn.yotpo.com/v1/widget/${this.yotpoKey}/products/${this.productId}/reviews.json?sort=rating&per_page=3`;
      const response = await fetch(baseUrl);
      const json = await response.json();

      if (json.status?.code === 200) {
        this.reviews = json.response.reviews;
        this.$nextTick(() => this.$refs.carousel.$swiper.update())
      }
    },
    updateSwiperAutoHeight() {
      this.$refs.carousel.$swiper.updateAutoHeight(500);
    },
    handleSlideChange() {
      this.$refs.carousel.$children.forEach(child => {
        child.resetReadMore();
      });
    },
  },
  template: `
  <section class="product-review-highlights OneLinkNoTx" :class="{'hidden': reviews.length === 0 }">
    <div class="product-review-highlights__header">
      <h2 class="product-review-highlights__heading h4" v-text="sectionTitle"></h2>
    </div>
    <div class="product-review-highlights__reviews">
      <vue-swiper
        class="swiper"
        ref="carousel"
        :watched-slides="reviews"
        :options="swiperOptions"
      >
        <div class="swiper-wrapper">
          <product-review-highlight
            v-for="review in reviews"
            :updateSwiperAutoHeight="updateSwiperAutoHeight"
            :review="review"
            :max-content="maxContent"
          >
          </product-review-highlight>
        </div>
        <div class="swiper-pagination"></div>
      </vue-swiper>
    </div>
  <section>
`};
